import React from "react";

export function PropertiesTable({ title, properties, translations })
{
    const element =
    <table className="table-sm table-bordered">
        <tbody>
            {properties && Object.entries(properties).map(([key, val]) =>
            {
                const translatedTitle = translations?.[title.toLowerCase()]?.[key] ?? key;
                const translatedValue = translations?.messages?.[val] ?? val;
                return <tr key={key}>
                    <th className="text-nowrap px-3">{translatedTitle}</th>
                    <td className="px-3">{translatedValue}</td>
                </tr>;
            })}
        </tbody>
    </table>;
    return element;
}